import React, { useState } from "react";
import { TextField, Button, Box, Container, Typography } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {useNavigate} from "react-router-dom";
const host = window?.location?.hostname ?? 'localhost'
const EnterEmail = () => {
    const [serverMessage, setServerMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [form, setForm] = useState({
        email: ""
    });

    const [errors, setErrors] = useState({
        email: "",
    });

    const validateEmail = (email) => {
        return /^[\w\.-]+@[\w\.-]+\.\w+$/.test(email);
    };

    const handleRegister = async () => {
        let email = form.email

        try {
            const response = await fetch(`https://${host}/enter_email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            let data;
            try {
                data = await response.json(); // Пытаемся разобрать JSON
            } catch {
                data = {}; // Если JSON нет или он битый, работаем без него
            }

            if (!response.ok) {
                // Если сервер вернул ошибку (4xx или 5xx)
                const errorMessage = data.message || `Ошибка ${response.status}: ${response.statusText}`;
                setErrorMessage(errorMessage);
                return;
            }
            setErrorMessage('')
            setIsConfirmed(true)
            if (data.message) {
                setServerMessage(data.message);
            } else {
                setServerMessage("Регистрация прошла успешно!");
            }

        } catch (error) {
            setErrorMessage("Ошибка сети или сервера. Проверьте подключение.");
        }
    };

    // Функция для обработки изменения значения в поле
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });

        // Валидация полей
        if (name === "email") {
            setErrors({ ...errors, email: validateEmail(value) ? "" : "Некорректный email" });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!errors.email) {
            console.log("Вход через почту успешен", form);
        }
    };

    return (
        <Container sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "top",
            height: "100vh",
            //marginTop:"-230px"
        }} >
            <Box  sx={{
                //marginTop: '50px',
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: 300,
                height: "560px",
                padding: 3,
                boxShadow: 3,
                textAlign: "center",
            }} >
                <Typography variant="h5" sx={{textAlign: "center", mb: 2}}>Вход через почту</Typography>
                <Typography variant="string" color='success' sx={{ textAlign: "center", mb: 2}}>{serverMessage ? serverMessage : ''}</Typography>
                <Typography variant="string" color='error' sx={{
                    position: 'fixed',
                    width: '300px',
                   // wordWrap:
                    marginTop: '32px',
                    marginLeft: '-32px',
                    textAlign: "center", mb: 2}}>{errorMessage ? errorMessage : ''}</Typography>
                {!isConfirmed ?
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Почта"
                            name="email"
                            type="email"
                            value={form.email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                            sx={{mb: 2}}
                        />
                        <Button
                            onClick={handleRegister}
                            fullWidth
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={!!errors.email || !form.email }
                        >
                            Выслать ссылку для входа на почту
                        </Button>
                        <br/><br/>
                        <Button variant="outlined" color="primary" onClick={() => {
                            navigate("/LoginForm")
                        }} fullWidth>
                            Назад
                        </Button>
                    </form> : ''}
            </Box>
        </Container>
    );
};

export default EnterEmail;
